import { ComponentProps, PropsWithChildren } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

type TooltipProps = {
  id: string;
} & PropsWithChildren &
  ComponentProps<typeof ReactTooltip>;

export const Tooltip = ({ id, children, ...dataAttributes }: TooltipProps) => {
  return (
    <div
      data-tooltip-content={dataAttributes.content || null}
      data-tooltip-id={id}
    >
      <ReactTooltip id={id} className="tooltip" {...dataAttributes} />
      {children}
    </div>
  );
};
